import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigurableTdContentComponent } from './configurable-td-content.component';
import { ConfigurableTablePipeModule } from "../../../pipes/configurable-table/configurable-table-pipe.module";
import { BookingStatusModule } from "../../booking/booking-status/booking-status.module";
import { RouterModule } from "@angular/router";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { BookingIconModule } from "../../../pipes/type-of/booking-icon.module";
import { ExternalBookingModule } from "../../external-booking/external-booking.module";
import { NoteModule } from "../../note/note.module";
import { BookingQualityControlDataModule } from "../../booking-quality-control-data/booking-quality-control-data.module";
import {
    SeatStatusSectorModule
} from "../../seat-status-sector/seat-status-sector.module";
import { IssueStatusModule } from "../../issue-status/issue-status.module";
import {
    TravellerQuantityModule
} from "../../traveller-quantity/traveller-quantity.module";
import { SearchFormPriceModule } from "../../search-form-price/search-form-price.module";
import { BookingSectorsModule } from "../../booking-sectors/booking-sectors.module";
import { StringWithLabelModule } from "libraries/component/string-with-label/string-with-label.module";
import { TextWithLabelModule } from "libraries/component/text-with-label/text-with-label.module";
import { FromToHyphenModule } from "libraries/component/from-to-hyphen/from-to-hyphen.module";
import { ValueWithNameModule } from "libraries/component/value-with-name/value-with-name.module";
import { PriceDetailModule } from "libraries/component/price-detail-bar/price-detail.module";
import { ConsumedDetailModule } from "libraries/component/consumed-detail-bar/consumed-detail.module";
import { InterfaceFlagModule } from "libraries/component/interface-flag/interface-flag.module";
import {
    FareOptimisationSummaryModule
} from "libraries/component/booking-information/components/booking-fare-optimisation-card/components/fare-optimisation-summary/fare-optimisation-summary.module";
import {
    BookingFareOptimisationCardModule
} from "libraries/component/booking-information/components/booking-fare-optimisation-card/booking-fare-optimisation-card.module";

@NgModule({
    declarations: [
        ConfigurableTdContentComponent
    ],
    exports: [
        ConfigurableTdContentComponent
    ],
    imports: [
        CommonModule,
        ConfigurableTablePipeModule,
        BookingStatusModule,
        RouterModule,
        BookingIconModule,
        FontAwesomeModule,
        ExternalBookingModule,
        NoteModule,
        BookingQualityControlDataModule,
        SeatStatusSectorModule,
        TravellerQuantityModule,
        SearchFormPriceModule,
        IssueStatusModule,
        BookingSectorsModule,
        StringWithLabelModule,
        TextWithLabelModule,
        FromToHyphenModule,
        ValueWithNameModule,
        PriceDetailModule,
        ConsumedDetailModule,
        InterfaceFlagModule,
        FareOptimisationSummaryModule,
        BookingFareOptimisationCardModule
    ]
})
export class ConfigurableTdContentModule {
}
